<template>
  <v-container grid-list-xl fluid fill-height>
    <v-layout wrap align-center justify-center>
      <v-card>

      </v-card>
      <v-card class="mx-auto" width="100%" max-width="500" outlined>
        <v-card-title>{{ $t('auth.createPassword') }}</v-card-title>
        <v-card-text>
          <v-form v-model="isValid">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="form.password"
                    :rules="rules.password"
                    :label="$t('auth.labels.newPassword')"
                    counter
                    :type="form.showPassword ? 'text' : 'password'"
                    @click:append="form.showPassword = !form.showPassword"
                    :append-icon="!form.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="form.confirmPassword"
                    :rules="rules.confirmPassword"
                    :label="$t('auth.labels.confirmPassword')"
                    counter
                    :type="form.showPasswordConfirmation ? 'text' : 'password'"
                    @click:append="form.showPasswordConfirmation = !form.showPasswordConfirmation"
                    :append-icon="!form.showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-btn
                    :disabled="!form.password || form.password !== form.confirmPassword"
                    rounded
                    depressed
                    color="primary"
                    @click="updatePassword">
                    {{ $t('ctas.save') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {

  name: 'ResetPassword',

  data () {
    return {
      isValid: false,
      form: {
        password: null,
        confirmPassword: null,
        showPassword: false,
        showPasswordConfirmation: false
      },
      rules: {
        password: [
          v => !!v || this.$t('validations.password')
        ],
        confirmPassword: [
          v => !!v || this.$t('validations.confirmPassword.required'),
          v => v === this.form.password || this.$t('validations.confirmPassword.match')
        ]
      }
    }
  },
  computed: {
    isValidMail () {
      return (this.$route.params.id === 1)
    }
  },
  methods: {
    async updatePassword () {
      try {
        await this.$api.post(`/passwords/set/${this.$route.params.token}`, {
          password: this.form.password
        })
        this.$toasted.success('Your password has been updated', {
          duration: 3000
        })
        this.$router.push('/login')
      } catch (e) {
        this.$toasted.error(e.message, { duration: 3000 })
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
